// extracted by mini-css-extract-plugin
export var colorSquare = "_rz-0";
export var danger = "_rz-5";
export var lightPink = "_rz-8";
export var neutralBlue = "_rz-7";
export var neutralYellow = "_rz-6";
export var normal = "_rz-1";
export var primary = "_rz-2";
export var primaryLight = "_rz-3";
export var solidBlack = "_rz-g";
export var solidGreen = "_rz-b";
export var solidLightBlue = "_rz-d";
export var solidNavy = "_rz-c";
export var solidOrange = "_rz-f";
export var solidPink = "_rz-e";
export var solidRed = "_rz-9";
export var solidYellow = "_rz-a";
export var success = "_rz-4";